import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tw-border tw-p-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm" }, " Copy the below values and paste them for the respective record types at your domain provider’s site. "),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-4 tw-text-sm tw-font-semibold" }, " Once the records are added, click on Verify CTA after waiting for a few minutes or time indicated by the record’s TTL (time-to-live) setting. ")
], -1)
const _hoisted_3 = { class: "tw-mb-4 tw-rounded-md tw-border" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-border-b tw-px-4 tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-font-mono tw-text-sm tw-text-slate-600" }, "TXT")
], -1)
const _hoisted_5 = { class: "tw-p-4" }
const _hoisted_6 = { class: "tw-mb-4 tw-rounded-md tw-border" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-border-b tw-px-4 tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-font-mono tw-text-sm tw-text-slate-600" }, "CNAME")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "tw-mb-4 tw-flex tw-justify-end"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-mb-4 tw-flex tw-justify-end"
}
const _hoisted_10 = { class: "tw-mb-4 tw-flex tw-gap-4 tw-rounded-md tw-border tw-p-4" }
const _hoisted_11 = { class: "tw-h-6 tw-w-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs" }, " DNS changes may take upto 72 hours to update depending on your host. If you have difficulties with this process, please reach out to your IT department for help. Until the changes are verified, you will see verification pending status for the email added and Goldcast default will be used for email notifications. ", -1)
const _hoisted_13 = {
  key: 0,
  class: "tw-mb-4 tw-flex tw-gap-4 tw-rounded-md tw-border tw-p-4"
}
const _hoisted_14 = { class: "tw-h-6 tw-w-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs" }, " DNS changes are either missing or still processing. Please add the records if you haven’t already. If you have already added the records, ensure the records are added with values specified above and wait for few minutes before clicking on Verify again. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioBadge = _resolveComponent("StudioBadge")!
  const _component_ExclamationTriangle = _resolveComponent("ExclamationTriangle")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, { moduleId: _ctx.moduleId }, {
    main: _withCtx(() => [
      (_ctx.isRetrieveVanityEmailDomainsLoading)
        ? (_openBlock(), _createBlock(_component_StudioSpinner, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_StudioInput, {
                  id: "dkim-host-read-only-input",
                  label: "Host (Name)",
                  class: "tw-mb-4",
                  modelValue: _ctx.getRecordValue?.txtRecord?.name,
                  showCopyToClipboard: "",
                  disabled: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_StudioInput, {
                  id: "dkim-value-read-only-input",
                  label: "Value",
                  modelValue: _ctx.getRecordValue?.txtRecord?.value,
                  showCopyToClipboard: "",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRecordValue?.cnameRecords, (record) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: record.value,
                  class: "tw-mt-2 tw-p-4"
                }, [
                  _createVNode(_component_StudioInput, {
                    id: "return-path-host-read-only-input",
                    label: "Host (Name)",
                    class: "tw-mb-4",
                    modelValue: record.name,
                    showCopyToClipboard: "",
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_StudioInput, {
                    id: "return-path-value-read-only-input",
                    label: "Value",
                    modelValue: record.value,
                    showCopyToClipboard: "",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", null, [
              (_ctx.vanityEmailDomain?.email_domain_verified)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_StudioBadge, { variation: "green" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Record Verified ")
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.isVerificationPending)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_StudioBadge, { variation: "red" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Verification Pending ")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ExclamationTriangle, { class: "tw-h-6 tw-w-6 tw-text-yellow-500" })
              ]),
              _hoisted_12
            ]),
            (_ctx.isVerifyButtonClicked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ExclamationTriangle, { class: "tw-h-6 tw-w-6 tw-text-yellow-500" })
                  ]),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["moduleId"]))
}